export default __webpack_public_path__ + "e-q-p-seal-gold.5f8f5ed01f435b91bd7d.svg";